<section id="head-section">
  <h2 class="visually-hidden ">{{data.hero_title}}</h2>
  <div class="container placeholder-glow">
    <div class="row">
      <div class="col-lg-6 order-2 order-lg-1">
        <div class="card mb-5">
          <div class="card-body pb-5 px-0">
            <div class="category-top">
              <svg class="icon icon-sm icon-primary me-2" aria-hidden="true" aria-label="Data">
                <use xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-calendar"></use>
              </svg>
              <span class="title-xsmall-semi-bold fw-bold">Notizie</span>
              <span class="data fw-normal">{{data.field_hero_upd_date | date}}</span>
            </div>
            <h3 class="card-title">{{data.hero_title}}
            </h3>
            <p class="mb-4 pt-3" [innerHTML]="data.hero_body.value"></p>
            <ng-container *ngIf="data.hero_tags.length > 0">
              <div *ngFor="let tag of data.hero_tags">
                <a class="chip chip-simple" [href]="tag.path?.alias">
                  <span class="chip-label">{{tag.title}}</span>
                </a>
              </div>
            </ng-container>
            <a class="read-more pb-3" [href]="data.hero_link?.alias"
              [target]="data.hero_link?.target_blank === true ? '_blank' : '_self'">
              <span class="text">{{data.hero_link?.title}}</span>
              <svg class="icon  icon-primary" [attr.aria-label]="data.hero_link?.title">
                <use xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-6 order-1 order-lg-2 px-0 px-lg-3" *ngIf="data.hero_image?.field_media_image?.uri?.url">
        <img fetchPriority="high"
          [src]="data.hero_image?.field_media_image?.uri?.url ? image(data.hero_image?.field_media_image?.uri?.url, 'hero') : ''"
          [title]="data.hero_image?.field_media_image?.meta?.title"
          [alt]="data.hero_image?.field_media_image?.meta?.alt" class="img-fluid" height="470px" width="630px">
      </div>
    </div>
  </div>
  <div class="section-muted pb-lg-50 px-lg-5 pt-0 bg-grey-card">
    <div class="container">
      <div class="row mb-2">
        <div
          class="card-wrapper px-0 card-overlapping card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3">
          <ng-container *ngFor="let hl of data.hero_highlighted">
            <div
              class="card card-teaser card-teaser-image card-flex no-after rounded shadow-sm border border-light mb-0">
              <div class="card-image-wrapper with-read-more">
                <div class="card-body p-3 pb-5">
                  <div class="category-top">
                    <span class="title-xsmall-semi-bold fw-semibold">{{hl.news_type?.name}}</span>
                  </div>
                  <h3 class="card-title text-paragraph-medium u-grey-light">{{hl.title}}</h3>
                  <p class="text-paragraph-card u-grey-light m-0">{{substring(hl.news_description,0,155)}}</p>
                </div>
                <div class="card-image card-image-rounded pb-5" *ngIf="hl?.news_image?.field_media_image?.uri?.url">
                  <img
                    [src]="hl?.news_image.field_media_image?.uri?.url ? image(hl?.news_image.field_media_image?.uri?.url, 'medium') : ''"
                    [title]="hl?.news_image.field_media_image?.meta?.title"
                    [alt]="hl?.news_image.field_media_image?.meta?.alt">
                </div>
              </div>
              <a class="read-more ps-3" [href]="hl.path.alias">
                <span class="text">Vai alla pagina</span>
                <svg class="icon" aria-label="Vai alla pagina">
                  <use xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
                </svg>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>